import { useState } from 'react';
import styles from './FAQ.module.css';

// Simple MainTitle component to replace the imported one
const MainTitle = ({ title, subTitleLine }) => (
  <div className={styles.mainTitleWrapper}>
    <h2 className={styles.sectionTitle}>{title}</h2>
    <p className={styles.sectionSubtitle}>{subTitleLine}</p>
  </div>
);

// Accordion Item Component
const AccordionItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className={`${styles.accordionItem} ${isOpen ? styles.open : ''}`}>
      <button className={styles.accordionHeader} onClick={onClick}>
        <h3 className={styles.accordionQuestion}>{question}</h3>
        <div className={styles.accordionIcon}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={isOpen ? styles.rotated : ''}
          >
            <path
              d="M19 9L12 16L5 9"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </button>
      <div className={`${styles.accordionContent} ${isOpen ? styles.expanded : ''}`}>
        <p className={styles.accordionAnswer}>{answer}</p>
      </div>
    </div>
  );
};

function FAQ({ faqData }) {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = id => {
    setOpenItems(prev => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <section className={styles.faqSection} id="faqId">
      <div className={styles.containerCustom}>
        <MainTitle
          title="Frequently Asked Questions"
          subTitleLine="Find answers to common questions about our service."
        />

        <div className={styles.faqContainer}>
          <div className={styles.faqCategory}>
            <h2 className={styles.categoryTitle}>For Renters</h2>
            <div className={styles.accordionContainer}>
              {faqData?.lenderFAQs?.map(faq => (
                <AccordionItem
                  key={faq.id}
                  question={faq.question}
                  answer={faq.answer}
                  isOpen={openItems[faq.id] || false}
                  onClick={() => toggleItem(faq.id)}
                />
              ))}
            </div>
          </div>

          <div className={styles.faqLendersSection}>
            <div className={styles.faqCategory}>
              <h2 className={styles.categoryTitle}>For Lenders</h2>
              <div className={styles.accordionContainer}>
                {faqData?.lenderFAQs?.map(faq => (
                  <AccordionItem
                    key={faq.id}
                    question={faq.question}
                    answer={faq.answer}
                    isOpen={openItems[faq.id] || false}
                    onClick={() => toggleItem(faq.id)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQ;
